import React from 'react';
import cn from 'classnames';
import styles from './styles.css';

const context = require.context('./svgs', true, /\.(svg)$/);
const icons = {};

context.keys().forEach(filename => {
  const key = filename.substring(filename.lastIndexOf('/') + 1, filename.lastIndexOf('.'));
  icons[key] = context(filename);
});

const Icon = ({ id, icon, className, ...props }) => {
  // Hack for SVG loader not being available in the test environment
  if (process.env.NODE_ENV === 'test') {
    return <span />;
  }

  const Icon = icons[icon];
  return <Icon id={id} className={cn(styles.container, className)} {...props} />;
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/icon/icon.jsx